import { Component, effect, inject, input, signal } from '@angular/core';
import { ThemeStore } from '@libs/core/lib/utils/theme/theme.store';
import { QRCodeComponent } from 'angularx-qrcode';
@Component({
  standalone: true,
  imports: [QRCodeComponent],
  selector: 'mtjr-qrcode',
  template: `
    <qrcode [qrdata]="qrdata()" [width]="width()" [colorDark]="darkColor()" [colorLight]="lightColor()"></qrcode>
  `,
})
export class VxQrCodeComponent {
  width = input(300);
  qrdata = input.required<string>();
  themeStore = inject(ThemeStore);
  darColorValue = '#1c1c1d';
  lightColorValue = '#ffffff';

  darkColor = signal(this.darColorValue);
  lightColor = signal(this.lightColorValue);

  constructor() {
    effect(() => {
      const isDarkMode = this.themeStore.usingDarkTheme();
      this.darkColor.set(isDarkMode ? this.lightColorValue : this.darColorValue);
      this.lightColor.set(isDarkMode ? this.darColorValue : this.lightColorValue);
    });
  }
}
